import { render, staticRenderFns } from "./ChangeFFModal.vue?vue&type=template&id=5122e356"
import script from "./ChangeFFModal.vue?vue&type=script&lang=js"
export * from "./ChangeFFModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports